import {
  checkIfAllTheDataFollowDDMMMYYYYFormat,
  checkIfAllTheDataFollowYYYYMMDDFormat,
  checkIfItsDDMMMYYYYFormatDate,
  convertRawZalproDateToActualDate,
  formatToYYYYMMDDFromTransworldRaw,
  getTransworldFormattedDate,
} from "./date";
import _ from "lodash";
import moment from "moment";
const currentDate = new Date();

const isValidDateValue = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (value instanceof Date) return !isNaN(value.getTime());
  const asString = String(value).trim();
  if (!asString) return false;
  const d = new Date(asString);
  if (!isNaN(d.getTime())) return true;
  return moment(asString, ["DD/MM/YYYY", "YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"], true).isValid();
};

const withImportError = (user: BulkUserImportData, message: string): BulkUserImportData => {
  const existing = (user as any).importErrors;
  const next = Array.isArray(existing) ? existing : [];
  return {
    ...user,
    importErrors: [...next, message],
  } as any;
};
export const importFormatIspTypes: NetwalaSelectOptions[] = [
  {
    value: "TRANSWORLD",
    label: "Transworld",
  },
  {
    value: "NBB",
    label: "NBB",
  },
  {
    value: "ZALPRO",
    label: "Zalpro",
  },
];

export const excelFormatTypes: NetwalaSelectOptions[] = [
  {
    value: "NETWALA",
    label: "Netwala",
  },
  {
    value: "JAZZ_ZONG",
    label: "Jazz / Zong",
  },
  {
    value: "REDTONE",
    label: "RedTone Billing System",
  },
];
export const handleTransworldDataImportAndFormulateTheData = (data: any[]) => {
  if (data.length < 1) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found`,
    };
  }

  const headers = data[0];
  const camelCaseHeaders = convertToCamelCase(headers);
  const dataRows = data.slice(1);
  let noPackage = 0;
  const formattedData: BulkUserImportData[] = [];
  const usersWithNoPackage: BulkUserImportData[] = [];
  const formatterCheckerArray: any = [];
  dataRows.map((row) => {
    const obj: any = {};
    if (row.length > 1) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        obj[header] = row[index];
      });
      formatterCheckerArray.push(obj);
    }
  });
  if (formatterCheckerArray.length < 1) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found`,
    };
  }
  // const firstObj = formatterCheckerArray.find(
  //   (obj:any) => obj.expiry !== null && obj.expiry !== ""
  // ); // formatterCheckerArray[0];
  let firstNonNullNameObject = null;
  for (const obj of formatterCheckerArray) {
    if (obj.expiry && !firstNonNullNameObject) {
      firstNonNullNameObject = obj;
      break; // Once found, break out of the loop
    }
  }
  if (!firstNonNullNameObject || !firstNonNullNameObject.expiry) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `Expiry is missing in all users. Please add expiry for every user (or skip those users).`,
    };
  }
  const { expiry } = firstNonNullNameObject;
  let formatType = 0;
  const isFirstType = checkIfItsDDMMMYYYYFormatDate(expiry);
  console.log({ isFirstType });
  if (isFirstType) {
    //it means we have the first type
    const doesAllFollow = checkIfAllTheDataFollowDDMMMYYYYFormat(
      formatterCheckerArray
    );
    if (!doesAllFollow) {
      return {
        packages: [],
        users: [],
        usersWithNoPackage: [],
        error: `Unknown Expiry Date Format,please contact with support!`,
      };
    }
    formatType = 1;
  } else {
    const isSecondType = formatToYYYYMMDDFromTransworldRaw(expiry);

    if (!isSecondType) {
      return {
        packages: [],
        users: [],
        usersWithNoPackage: [],
        error: `Unknown Expiry Date Format,please contact with support!`,
      };
    }
    const doesAllFollow = checkIfAllTheDataFollowYYYYMMDDFormat(
      formatterCheckerArray
    );
    if (!doesAllFollow) {
      return {
        packages: [],
        users: [],
        usersWithNoPackage: [],
        error: `Unknown Expiry Date Format,please contact with support!`,
      };
    }
    formatType = 2;
  }
  if (formatType === 0) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `Unknown Expiry Date Format,please contact with support!`,
    };
  }
  dataRows.map((row) => {
    const obj: any = {};
    if (row.length > 1) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        obj[header] = row[index];
      });
      //lets build the object that we need
      //name,address,username,password,expiry,mobileNo,package,city
      const { firstName, lastName } = normalizeName(obj.name || "");
      const id = Math.random().toString();
      const hasValidExpiry = isValidDateValue(obj.expiry);
      const dataObject: BulkUserImportData = {
        firstName,
        lastName,
        expiryDate: hasValidExpiry
          ? getTransworldFormattedDate(obj.expiry, formatType)
          : "",
        username: obj.username || "",
        password: obj.username || "",
        phoneNumber: normalizePhoneNumber(obj["mobileNo."] || ""),
        packageName: obj.package || "",
        city: obj.city || "",
        address: obj.address || "",
        expiry: obj.expiry || "",
        name: obj.name || "",
        id: id,
        intPkPackageID: null,
        mappedPackageName: "",
        balance: 0,
      };
      // Add to missed users if username is not available, or if no package
      if (!hasValidExpiry) {
        noPackage++;
        usersWithNoPackage.push(withImportError(dataObject, "Expiry is missing or invalid"));
      } else if (!obj.username) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else if (!obj.package) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else {
        formattedData.push(dataObject);
      }
    }
  });
  const uniquePackages = _.uniqBy(formattedData, "packageName")
    .map((item) => item.packageName)
    .filter((item) => item !== "");
  console.log({
    uniquePackages: uniquePackages,
    formattedData: formattedData,
    usersWithNoPackage: usersWithNoPackage,
  });
  return {
    packages: uniquePackages,
    users: formattedData,
    usersWithNoPackage: usersWithNoPackage,
    error: null,
  };
};
export const handleZalProDataImportAndFormulateTheData = (data: any[]) => {
  if (data.length < 1) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found`,
    };
  }
  console.log({ data });

  const headers = data[0];
  const camelCaseHeaders = convertToCamelCase(headers);
  console.log({ camelCaseHeaders });
  const dataRows = data.slice(1);
  let noPackage = 0;
  const formattedData: BulkUserImportData[] = [];
  const usersWithNoPackage: BulkUserImportData[] = [];
  dataRows.map((row) => {
    const obj: any = {};
    if (row.length > 1) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        obj[header] = row[index];
      });
      //lets build the object that we need
      //name,address,username,password,expiry,mobileNo,package,city
      //""
      const { firstName, lastName } = normalizeName(obj.fullName || "");
      const id = Math.random().toString();
      const _balance = obj.balance || 0;
      const hasValidExpiry = isValidDateValue(obj.expiry);

      const dataObject: BulkUserImportData = {
        firstName,
        lastName,
        expiryDate: hasValidExpiry
          ? convertRawZalproDateToActualDate(obj.expiry)
          : "",
        username: obj.username || "",
        password: obj.username || "",
        phoneNumber: normalizePhoneNumber(obj.phone || ""),
        packageName: obj.package || "",
        city: obj.city || "",
        address: obj.address || "",
        expiry: obj.expiry || "",
        name: obj.fullName || "",
        id: id,
        intPkPackageID: null,
        mappedPackageName: "",
        balance: Number(_balance) >= 0 ? _balance : 0,
      };
      // Add to missed users if username is not available, or if no package
      if (!hasValidExpiry) {
        noPackage++;
        usersWithNoPackage.push(withImportError(dataObject, "Expiry is missing or invalid"));
      } else if (!obj.username) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else if (!obj.package) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else {
        formattedData.push(dataObject);
      }
    }
  });
  const uniquePackages = _.uniqBy(formattedData, "packageName")
    .map((item) => item.packageName)
    .filter((item) => item !== "");
  console.log({ uniquePackages, formattedData, usersWithNoPackage });
  return {
    packages: uniquePackages,
    users: formattedData,
    usersWithNoPackage: usersWithNoPackage,
    error: null,
  };
};
export const handleNBBDataImportAndFormulateTheData = (data: any[]) => {
  if (data.length < 1) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found`,
    };
  }

  const headers = data[0];
  const camelCaseHeaders = convertToCamelCase(headers);
  const dataRows = data.slice(1);
  let noPackage = 0;
  const formattedData: BulkUserImportData[] = [];
  const usersWithNoPackage: BulkUserImportData[] = [];
  console.log({ camelCaseHeaders });
  dataRows.map((row, index) => {
    const obj: any = {};
    if (row.length > 1) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        obj[header] = row[index];
      });
      const { firstName, lastName } = normalizeName(obj.fullName || "");
      const id = Math.random().toString();
      const hasValidExpiry = isValidDateValue(obj.expirationDate);
      const dataObject: BulkUserImportData = {
        firstName,
        lastName,
        expiryDate: hasValidExpiry ? obj.expirationDate : "",
        username: obj.username || "",
        password: obj.username || "",
        phoneNumber: normalizePhoneNumber(obj.mobile || ""),
        packageName: obj.package || "",
        city: obj.city || "",
        address: obj.address || "",
        expiry: obj.expirationDate || "",
        name: obj.fullName || "",
        id: id,
        intPkPackageID: null,
        mappedPackageName: "",
        balance: 0,
      };
      // Add to missed users if username is not available, or if no package
      if (!hasValidExpiry) {
        noPackage++;
        usersWithNoPackage.push(withImportError(dataObject, "Expiry is missing or invalid"));
      } else if (!obj.username) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else if (!obj.package) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else {
        formattedData.push(dataObject);
      }
    }
  });
  const uniquePackages = _.uniqBy(formattedData, "packageName")
    .map((item) => item.packageName)
    .filter((item) => item !== "");
  console.log({ uniquePackages, formattedData, usersWithNoPackage });
  return {
    packages: uniquePackages,
    users: formattedData,
    usersWithNoPackage: usersWithNoPackage,
    error: null,
  };
};
const convertToCamelCase = (headers: string[]) => {
  const toCamelCase = (str: string) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, ""); // Remove spaces
  };

  // Convert headers to camel case
  const camelCaseHeaders = headers.map((header: string) => toCamelCase(header));
  return camelCaseHeaders;
};
const normalizeName = (fullName: string) => {
  const names = fullName.split(" ");

  if (names.length === 1) {
    return { firstName: fullName, lastName: "" };
  } else if (names.length === 2) {
    return { firstName: names[0], lastName: names[1] };
  } else {
    const firstName = names[0];
    const lastName = names.slice(1).join(" ");
    return { firstName, lastName };
  }
};

const normalizePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber || phoneNumber.trim() === "") {
    return "";
  }
  const trimmed = phoneNumber.trim(); // .replace("-", "");
  // If phone number doesn't start with "0", prepend it
  if (
    trimmed &&
    !trimmed.startsWith("0") &&
    !trimmed.startsWith("+92") &&
    !trimmed.startsWith("92")
  ) {
    return "0" + trimmed;
  }
  return trimmed;
};

export const handleJazzZongExcelDataImportAndFormulateTheData = (
  data: any[]
) => {
  if (data.length < 1) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found`,
    };
  }

  // Check if first row is header (has more than 2-3 non-empty values)
  const firstRow = data[0] || [];
  const firstRowNonEmptyCount = firstRow.filter(
    (cell: any) => cell !== null && cell !== undefined && cell !== ""
  ).length;

  let headers: any[];
  let dataRows: any[];

  if (firstRowNonEmptyCount > 3) {
    // First row is header
    headers = data[0];
    dataRows = data.slice(1);
  } else {
    // Second row is header
    if (data.length < 2) {
      return {
        packages: [],
        users: [],
        usersWithNoPackage: [],
        error: `No Data Found`,
      };
    }
    headers = data[1];
    dataRows = data.slice(2);
  }

  console.log({ headers, firstRowNonEmptyCount });
  const camelCaseHeaders = convertToCamelCase(headers);
  let noPackage = 0;
  const formattedData: BulkUserImportData[] = [];
  const usersWithNoPackage: BulkUserImportData[] = [];

  console.log("Jazz/Zong Excel headers:", headers);
  console.log("Jazz/Zong CamelCase headers:", camelCaseHeaders);
  console.log("Jazz/Zong Data rows:", dataRows);
  dataRows.forEach((row) => {
    if (!row || !Array.isArray(row)) {
      return; // Skip invalid rows
    }

    const obj: any = {};

    // Check if row has any meaningful data - check if any cell has a non-empty value
    const hasData = row.some(
      (cell: any) => cell !== null && cell !== undefined && cell !== ""
    );

    if (hasData) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        const value = row[index];
        // Preserve number type for dates (Excel serial dates), convert others to string
        if (value !== undefined && value !== null) {
          // Keep numbers as numbers (for Excel date serial numbers)
          // Convert everything else to string
          obj[header] =
            typeof value === "number" ? value : String(value).trim();
        } else {
          obj[header] = "";
        }
      });

      console.log("Jazz/Zong Parsed row object:", obj);

      // Jazz/Zong format: Name / Username (separated by ●), Package, Seller (skip), Balance, Expiry
      // Parse Name/Username column - split by ●
      const nameUsernameField =
        obj["name/Username"] || obj["nameUsername"] || "";
      let name = "";
      let username = "";

      if (nameUsernameField.includes("●")) {
        const parts = nameUsernameField.split("●");
        name = parts[0]?.trim() || "";
        username = parts[1]?.trim() || "";
      } else {
        // If no bullet separator, try to split by other common separators
        name = nameUsernameField;
        username = nameUsernameField; // Fallback to same value
      }

      const { firstName, lastName } = normalizeName(name || "");
      const id = Math.random().toString();
      const _balance = obj.balance || 0;

      // Parse expiryDate (format: could be DD/MM/YYYY or Excel serial number)
      let expiryDate: Date | "" = "";
      if (obj.expiry) {
        const dateValue = obj.expiry;

        // Check if it's an Excel serial number (numeric value, typically 5 digits)
        if (
          typeof dateValue === "number" &&
          dateValue > 0 &&
          dateValue < 1000000
        ) {
          // Excel serial date: days since January 1, 1900
          const excelEpoch = moment("1900-01-01");
          const days = Math.floor(dateValue) - 2; // Subtract 2 to account for Excel's 1900 leap year bug
          const parsedDate = excelEpoch.add(days, "days");
          if (parsedDate.isValid()) {
            expiryDate = parsedDate.endOf("day").toDate();
          }
        } else {
          const dateStr = String(dateValue).trim();
          // Check if it's in DD/MM/YYYY format
          if (dateStr.includes("/")) {
            // Parse DD/MM/YYYY format using moment
            const parsedDate = moment(dateStr, "DD/MM/YYYY", true);
            if (parsedDate.isValid()) {
              // Set time to end of day (23:59:59)
              expiryDate = parsedDate.endOf("day").toDate();
            }
          } else {
            // Try standard date parsing for other formats
            const parsedDate = moment(dateValue);
            if (parsedDate.isValid()) {
              expiryDate = parsedDate.toDate();
            }
          }
        }
      }

      const dataObject: BulkUserImportData = {
        firstName,
        lastName,
        expiryDate: expiryDate,
        username: username || "",
        password: username || "", // Use username as password default
        phoneNumber: normalizePhoneNumber(""), // Not available in Jazz/Zong format
        packageName: obj.package || "",
        city: "", // Not available in Jazz/Zong format
        address: "", // Not available in Jazz/Zong format
        expiry: obj.expiry || "",
        name: name || "",
        id: id,
        intPkPackageID: null,
        mappedPackageName: "",
        balance: Number(_balance) >= 0 ? Number(_balance) : 0,
      };
      console.log({ dataObject });

      // Add to missed users if username is not available, or if no package
      if (!expiryDate) {
        noPackage++;
        usersWithNoPackage.push(withImportError(dataObject, "Expiry is missing or invalid"));
      } else if (!username) {
        console.log("Adding to missed users - no username");
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else if (!obj.package) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else {
        formattedData.push(dataObject);
      }
    }
  });

  const uniquePackages = _.uniqBy(formattedData, "packageName")
    .map((item) => item.packageName)
    .filter((item) => item !== "");

  return {
    packages: uniquePackages,
    users: formattedData,
    usersWithNoPackage: usersWithNoPackage,
    error: null,
  };
};

export const handleNetwalaExcelDataImportAndFormulateTheData = (
  data: any[]
) => {
  if (data.length < 1) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found`,
    };
  }

  const headers = data[0];
  const camelCaseHeaders = convertToCamelCase(headers);
  const dataRows = data.slice(1);
  let noPackage = 0;
  const formattedData: BulkUserImportData[] = [];
  const usersWithNoPackage: BulkUserImportData[] = [];

  console.log("Excel headers:", headers);
  console.log("CamelCase headers:", camelCaseHeaders);
  console.log("Data rows:", dataRows);

  dataRows.forEach((row) => {
    if (!row || !Array.isArray(row)) {
      return; // Skip invalid rows
    }

    const obj: any = {};

    // Check if row has any meaningful data - check if any cell has a non-empty value
    const hasData = row.some(
      (cell: any) => cell !== null && cell !== undefined && cell !== ""
    );

    if (hasData) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        const value = row[index];
        // Preserve number type for dates (Excel serial dates), convert others to string
        if (value !== undefined && value !== null) {
          // Keep numbers as numbers (for Excel date serial numbers)
          // Convert everything else to string
          obj[header] =
            typeof value === "number" ? value : String(value).trim();
        } else {
          obj[header] = "";
        }
      });

      console.log("Parsed row object:", obj);

      // Excel format: name, username, password, phone, package, city, address, expiryDate, balance
      const { firstName, lastName } = normalizeName(obj.name || "");
      const id = Math.random().toString();
      const _balance = obj.balance || 0;

      // Parse expiryDate (format: 16/11/2025 or 2025-11-16 23:59:59 or Excel serial number)
      let expiryDate: Date | "" = "";
      if (obj.expiryDate) {
        const dateValue = obj.expiryDate;

        // Check if it's an Excel serial number (numeric value, typically 5 digits)
        if (
          typeof dateValue === "number" &&
          dateValue > 0 &&
          dateValue < 1000000
        ) {
          // Excel serial date: days since January 1, 1900
          // Excel incorrectly treats 1900 as a leap year, so we need to adjust
          const excelEpoch = moment("1900-01-01");
          const days = Math.floor(dateValue) - 2; // Subtract 2 to account for Excel's 1900 leap year bug
          const parsedDate = excelEpoch.add(days, "days");
          if (parsedDate.isValid()) {
            expiryDate = parsedDate.endOf("day").toDate();
          }
        } else {
          const dateStr = String(dateValue).trim();
          // Check if it's in DD/MM/YYYY format
          if (dateStr.includes("/")) {
            // Parse DD/MM/YYYY format using moment
            const parsedDate = moment(dateStr, "DD/MM/YYYY", true);
            if (parsedDate.isValid()) {
              // Set time to end of day (23:59:59)
              expiryDate = parsedDate.endOf("day").toDate();
            }
          } else {
            // Try standard date parsing for other formats
            const parsedDate = moment(dateValue);
            if (parsedDate.isValid()) {
              expiryDate = parsedDate.toDate();
            }
          }
        }
      }

      const dataObject: BulkUserImportData = {
        firstName,
        lastName,
        expiryDate: expiryDate,
        username: obj.username || "",
        password: obj.password || obj.username || "",
        phoneNumber: normalizePhoneNumber(obj.phone || ""),
        packageName: obj.package || "",
        city: obj.city || "",
        address: obj.address || "",
        expiry: obj.expiryDate || "",
        name: obj.name || "",
        id: id,
        intPkPackageID: null,
        mappedPackageName: "",
        balance: Number(_balance) >= 0 ? Number(_balance) : 0,
      };
      console.log({ dataObject });

      // Add to missed users if username is not available, or if no package
      if (!expiryDate) {
        noPackage++;
        usersWithNoPackage.push(withImportError(dataObject, "Expiry is missing or invalid"));
      } else if (!obj.username) {
        console.log("Adding to missed users - no username");
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else if (!obj.package) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else {
        formattedData.push(dataObject);
      }
    }
  });

  const uniquePackages = _.uniqBy(formattedData, "packageName")
    .map((item) => item.packageName)
    .filter((item) => item !== "");

  return {
    packages: uniquePackages,
    users: formattedData,
    usersWithNoPackage: usersWithNoPackage,
    error: null,
  };
};

export const handleRedToneExcelDataImportAndFormulateTheData = (
  data: any[]
) => {
  if (data.length < 3) {
    return {
      packages: [],
      users: [],
      usersWithNoPackage: [],
      error: `No Data Found - Need at least 3 rows (title, header, and data)`,
    };
  }

  // Skip row 0 (title row), use row 1 as headers, process rows 2+ as data
  const headers = data[1];
  const camelCaseHeaders = convertToCamelCase(headers);
  const dataRows = data.slice(2); // Skip first two rows (title and header)
  let noPackage = 0;
  const formattedData: BulkUserImportData[] = [];
  const usersWithNoPackage: BulkUserImportData[] = [];

  console.log("RedTone Excel headers:", headers);
  console.log("RedTone CamelCase headers:", camelCaseHeaders);
  console.log("RedTone Data rows:", dataRows);

  dataRows.forEach((row) => {
    if (!row || !Array.isArray(row)) {
      return; // Skip invalid rows
    }

    const obj: any = {};

    // Check if row has any meaningful data
    const hasData = row.some(
      (cell: any) => cell !== null && cell !== undefined && cell !== ""
    );

    if (hasData) {
      camelCaseHeaders.forEach((header: any, index: number) => {
        const value = row[index];
        if (value !== undefined && value !== null) {
          obj[header] =
            typeof value === "number" ? value : String(value).trim();
        } else {
          obj[header] = "";
        }
      });

      console.log("RedTone Parsed row object:", obj);

      // RedTone format: #, Username, Owner, Address, Mobile, Phone, Cnic, Service, Expiration, Action
      // Username column contains: "FA ... farazali" where FA is name and farazali is username

      // Parse username column to extract name and username
      // Format: "FA                                                …                                         farazali"
      const usernameField = String(obj.username || "").trim();
      let name = "";
      let username = "";

      if (usernameField) {
        // Split by whitespace and filter out empty strings
        const parts = usernameField
          .split(/\s+/)
          .filter((part) => part.trim() !== "");

        if (parts.length > 0) {
          // First part is the name
          name = parts[0].trim();
          // Last part is the username
          username = parts[parts.length - 1].trim();
        } else {
          // Fallback: use the whole field as username if we can't parse it
          username = usernameField;
        }
      }

      const { firstName, lastName } = normalizeName(name || "");
      const id = Math.random().toString();
      const _balance = 0; // Balance not available in RedTone format

      // Parse expiryDate from Expiration column
      // Format: '2025-11-16 12:00:003 days 5 hours ago' or similar
      let expiryDate: Date | "" = "";
      if (obj.expiration) {
        const expirationStr = String(obj.expiration).trim();

        // Try to extract the date part (before "days" or "hours ago")
        // Look for YYYY-MM-DD pattern
        const dateMatch = expirationStr.match(/(\d{4}-\d{2}-\d{2})/);
        if (dateMatch) {
          const dateStr = dateMatch[1];
          const parsedDate = moment(dateStr, "YYYY-MM-DD", true);
          if (parsedDate.isValid()) {
            expiryDate = parsedDate.endOf("day").toDate();
          }
        } else {
          // Try standard date parsing
          const parsedDate = moment(expirationStr);
          if (parsedDate.isValid()) {
            expiryDate = parsedDate.toDate();
          }
        }
      }

      // Use Mobile if available, otherwise Phone
      const phoneNumber = normalizePhoneNumber(obj.mobile || obj.phone || "");

      const dataObject: BulkUserImportData = {
        firstName,
        lastName,
        expiryDate: expiryDate,
        username: username || "",
        password: username || "", // Use username as password default
        phoneNumber: phoneNumber,
        packageName: obj.service || "",
        city: "", // Not available in RedTone format
        address: obj.address || "",
        expiry: obj.expiration || "",
        name: name || "",
        id: id,
        intPkPackageID: null,
        mappedPackageName: "",
        balance: Number(_balance) >= 0 ? Number(_balance) : 0,
      };
      console.log({ dataObject });

      // Add to missed users if username is empty, or if no service/package
      if (!expiryDate) {
        noPackage++;
        usersWithNoPackage.push(withImportError(dataObject, "Expiry is missing or invalid"));
      } else if (!username) {
        console.log("Adding to missed users - no username");
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else if (!obj.service) {
        noPackage++;
        usersWithNoPackage.push(dataObject);
      } else {
        formattedData.push(dataObject);
      }
    }
  });

  const uniquePackages = _.uniqBy(formattedData, "packageName")
    .map((item) => item.packageName)
    .filter((item) => item !== "");

  return {
    packages: uniquePackages,
    users: formattedData,
    usersWithNoPackage: usersWithNoPackage,
    error: null,
  };
};
